"use strict";
/*!
 * devextreme-angular
 * Version: 18.2.4
 * Build date: Thu Dec 20 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
Object.defineProperty(exports, "__esModule", { value: true });
function getElement(element) {
    return element.get ? element.get(0) : element;
}
exports.getElement = getElement;
;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme-angular/core/utils.js
// module id = ../../../../devextreme-angular/core/utils.js
// module chunks = common